var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContact3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.8446 18.7234H40.0007C40.0007 8.04988 31.9524 0 21.2773 0V4.16122C29.7185 4.16122 35.8446 10.2845 35.8446 18.7234Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0223 12.6738C25.4431 12.6738 27.3288 14.5593 27.3288 18.9798H31.5331C31.5331 12.2008 27.8018 8.46976 21.0223 8.46976V12.6738ZM28.2159 24.1151C27.812 23.748 27.2812 23.5522 26.7356 23.569C26.19 23.5859 25.6723 23.8141 25.2918 24.2055L20.2613 29.3785C19.0505 29.1473 16.6161 28.3885 14.1104 25.8892C11.6046 23.3815 10.8457 20.941 10.6208 19.7387L15.79 14.7064C16.1819 14.3262 16.4104 13.8085 16.4273 13.2628C16.4442 12.7171 16.248 12.1862 15.8804 11.7825L8.11286 3.24204C7.74507 2.8371 7.2339 2.59147 6.68791 2.55733C6.14193 2.52318 5.60413 2.7032 5.18875 3.05916L0.62704 6.97102C0.263598 7.33575 0.0466713 7.82118 0.0174101 8.33523C-0.0141225 8.86073 -0.615343 21.3089 9.03782 30.9656C17.4591 39.3841 28.0078 40 30.913 40C31.3376 40 31.5983 39.9874 31.6677 39.9832C32.1817 39.9544 32.6669 39.7366 33.0299 39.3715L36.9399 34.808C37.2962 34.393 37.4766 33.8554 37.4428 33.3094C37.409 32.7635 37.1638 32.2522 36.7591 31.8841L28.2159 24.1151Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContact3);
export default __webpack_public_path__ + "static/media/contact3.b66470a2083fc8f3caf51147444bd57b.svg";
export { ForwardRef as ReactComponent };